var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"font-size":"12px"}},[_vm._v("距结束"),_c('span',[_vm._v(_vm._s(_vm.count))])])}
var staticRenderFns = []

export { render, staticRenderFns }